var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-dropdown",
    { attrs: { "no-flip": "no-flip" } },
    [
      _c("template", { slot: "button-content" }, [
        _vm.selected
          ? _c("label", [_vm._v(_vm._s(_vm.placeholder))])
          : _vm._e(),
        _c("h1", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm.data.length > _vm.limit
        ? _c("b-dropdown-form", [
            _c("form", { staticStyle: { padding: "0 10px" } }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", [_vm._v(_vm._s(_vm.placeholder))]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter,
                      expression: "filter"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { placeholder: "Filtrar` lista" },
                  domProps: { value: _vm.filter },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.filter = $event.target.value
                    }
                  }
                })
              ])
            ])
          ])
        : _vm._e(),
      _vm.data.length > _vm.limit ? _c("b-dropdown-divider") : _vm._e(),
      _vm.showall
        ? _c(
            "b-dropdown-item-button",
            {
              on: {
                click: function($event) {
                  return _vm.select(null)
                }
              }
            },
            [_vm._v("Todos")]
          )
        : _vm._e(),
      _vm._l(_vm.list, function(row, index) {
        return _c(
          "b-dropdown-item-button",
          {
            key: index,
            on: {
              click: function($event) {
                return _vm.select(row)
              }
            }
          },
          [_vm._v(_vm._s(_vm.get_label(row)))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8d647d80", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d647d80","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/indicators/filter.vue
// module id = 1183
// module chunks = 0